import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'

export default {



  async fetchCustomersItems({ commit, state }, payload) {
    try {
      // Verificar se já temos dados em cache válido
      const now = Date.now()
      if (state.lastFetch && (now - state.lastFetch) < state.cacheExpiry && state.customersAll.length > 0) {
        // Aplicar filtro inicial se não há busca
        commit('FILTER_CUSTOMERS_LOCAL', { searchTerm: '', limit: 50 })
        return state.customersAll
      }

      commit('SET_LOADING', true)
      payload.loading()

      const response = await axios.get(`${baseApiUrl}/customers/getAllCustomers`)
      
      commit('SET_CUSTOMERS', response.data)
      commit('SET_LAST_FETCH', now)
      
      // Filtrar inicialmente para mostrar apenas os primeiros 50
      commit('FILTER_CUSTOMERS_LOCAL', { searchTerm: '', limit: 50 })

      return response.data
    } catch (error) {
      console.log(error)
      throw error
    } finally {
      commit('SET_LOADING', false)
      payload.loading.close()
    }
  },

  async searchCustomers({ commit, state }, { searchTerm, limit = 50 }) {
    commit('SET_SEARCH_TERM', searchTerm)

    if (!searchTerm || searchTerm.length < 2) {
        commit('FILTER_CUSTOMERS_LOCAL', { searchTerm: '', limit })
        return state.customersFiltered
    }

    const cacheKey = `${searchTerm.toLowerCase()}_${limit}`
    
    // Verificar cache primeiro
    const cached = state.searchCache.get(cacheKey)
    if (cached && (Date.now() - cached.timestamp) < state.cacheExpiry) {
        commit('SET_CUSTOMERS_FILTERED', cached.data)
        return cached.data
    }

    try {
        commit('SET_LOADING', true)
        
        // MUDANÇA: Sempre fazer busca na API para termos específicos
        // Isso garante que encontramos clientes que não estão no cache local
        if (searchTerm.length >= 2) {
            //console.log('Buscando clientes da API para:', searchTerm)
            
            const response = await axios.get(`${baseApiUrl}/customers/search`, {
                params: { term: searchTerm, limit }
            })
            
            commit('SET_CUSTOMERS_FILTERED', response.data)
            commit('SET_SEARCH_CACHE', { 
                key: cacheKey, 
                data: response.data 
            })
            
            return response.data
        }
        
        // Para busca vazia, usar dados locais
        commit('FILTER_CUSTOMERS_LOCAL', { searchTerm, limit })
        return state.customersFiltered
        
    } catch (error) {
        console.error('Erro na busca de clientes:', error)
        // Se erro na API, tentar filtrar localmente como fallback
        if (state.customersAll.length > 0) {
            commit('FILTER_CUSTOMERS_LOCAL', { searchTerm, limit })
            return state.customersFiltered
        }
        throw error
    } finally {
        commit('SET_LOADING', false)
    }
},

  /* // Nova action para busca otimizada
  async searchCustomers({ commit, state }, { searchTerm, limit = 50 }) {
    commit('SET_SEARCH_TERM', searchTerm)

    if (!searchTerm || searchTerm.length < 2) {
      commit('FILTER_CUSTOMERS_LOCAL', { searchTerm: '', limit })
      return state.customersFiltered
    }

    const cacheKey = `${searchTerm.toLowerCase()}_${limit}`
    
    // Verificar cache primeiro
    const cached = state.searchCache.get(cacheKey)
    if (cached && (Date.now() - cached.timestamp) < state.cacheExpiry) {
      commit('SET_CUSTOMERS_FILTERED', cached.data)
      return cached.data
    }

    try {
      commit('SET_LOADING', true)
      
      // Se temos todos os clientes, filtrar localmente (mais rápido)
      if (state.customersAll.length > 0) {
        commit('FILTER_CUSTOMERS_LOCAL', { searchTerm, limit })
        
        // Salvar no cache
        commit('SET_SEARCH_CACHE', { 
          key: cacheKey, 
          data: state.customersFiltered 
        })
        
        return state.customersFiltered
      } else {
        console.log('Buscando clientes da API...')
        // Se não temos dados, buscar da API
        const response = await axios.get(`${baseApiUrl}/customers/search`, {
          params: { term: searchTerm, limit }
        })
        
        commit('SET_CUSTOMERS_FILTERED', response.data)
        commit('SET_SEARCH_CACHE', { 
          key: cacheKey, 
          data: response.data 
        })
        
        return response.data
      }
    } catch (error) {
      console.error('Erro na busca de clientes:', error)
      // Se erro na API, tentar filtrar localmente
      if (state.customersAll.length > 0) {
        commit('FILTER_CUSTOMERS_LOCAL', { searchTerm, limit })
        return state.customersFiltered
      }
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }, */

  // Action para carregar dados paginados
  async loadCustomersPage({ commit, state }, { page = 1, itemsPerPage = 50, searchTerm = '' }) {
    commit('SET_CURRENT_PAGE', page)
    
    const startIndex = (page - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    
    let filteredData = state.customersAll
    
    if (searchTerm && searchTerm.length >= 2) {
      const term = searchTerm.toLowerCase()
      filteredData = state.customersAll.filter(customer => 
        (customer.corporateName && customer.corporateName.toLowerCase().includes(term)) ||
        (customer.idIlux && customer.idIlux.toString().includes(term)) ||
        (customer.cnpj && customer.cnpj.includes(term)) ||
        (customer.cpf && customer.cpf.includes(term))
      )
    }
    
    const paginatedData = filteredData.slice(startIndex, endIndex)
    commit('SET_CUSTOMERS_FILTERED', paginatedData)
    
    return {
      data: paginatedData,
      total: filteredData.length,
      currentPage: page
    }
  },

  // Limpar cache expirado
  clearExpiredCache({ commit }) {
    commit('CLEAR_EXPIRED_CACHE')
  },

  // Actions originais mantidas
  async addNewCustomer({ commit }, payload) {
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/customers/save`, payload.customer)
      payload.customer.idCustomer = res.data
      commit('ADD_NEW_CUSTOMER', payload.customer)
      commit('ADD_CUSTOMER_FILTERED', payload.customer)
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      if(error.response.status == '409'){
        payload.notify({
          title: "Duplicado",
          text: "Código Ilux já cadastrado. " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        })
      }else{
        payload.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        })
      }
    }finally{
      payload.loading.close()
    }
  },

  async updateCustomer({ commit }, payload) {
    try {
      await axios.post(`${baseApiUrl}/customers/update`, payload.customer)
      commit('UPDATE_CUSTOMER', payload.customer)
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      if(error.response.status == '409'){
        payload.notify({
          title: "Duplicado",
          text: "Código Ilux já cadastrado. " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        })
      }else{
        payload.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        })
      }
    }
  },

  async removeCustomer({ commit }, payload) {
    let idCustomer = payload.idCustomer
    try {
      await axios.post(`${baseApiUrl}/customers/remove`, { idCustomer })
      commit('REMOVE_CUSTOMER', idCustomer)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  }
}